/* global ajax */
/* eslint-disable */

function uploadFile() {
    const messageDiv = jQuery('.js-message')[0];
    jQuery(messageDiv).removeClass('error');
    jQuery(messageDiv).empty('error');

    var fd = new FormData();
    fd.append('action', 'excel_converter');
    fd.append('excelFile', jQuery('#excelFile')[0].files[0]);
    fd.append('addressColumn', jQuery('#addressColumn').val());
    fd.append('cityColumn', jQuery('#cityColumn').val());
    fd.append('postcodeColumn', jQuery('#postcodeColumn').val());
    fd.append('countryColumn', jQuery('#countryColumn').val());
    fd.append('latitudeColumn', jQuery('#latitudeColumn').val());
    fd.append('longitudeColumn', jQuery('#longitudeColumn').val());

    jQuery.ajax({
        url: ajax.url,
        type: 'POST',
        processData: false,
        contentType: false,
        data: fd,
        success: (response) => {
            jQuery(messageDiv).removeClass('d-none');
            const jsonResponse = JSON.parse(response);
            messageDiv.innerHTML += jsonResponse.text + '<br><br>';
            messageDiv.innerHTML += '<h4 class="mb-0">Resultaten:</h4>';
            jsonResponse['responses'].forEach(result => {
                messageDiv.innerHTML += result.text;
                messageDiv.innerHTML += '<br>';
            });

            messageDiv.innerHTML += '<br><a href="' + jsonResponse.result.path + jsonResponse.result.file + '" class="btn btn-xs-block btn-primary mr-2 mb-1" download>Download nieuwe excel</a>';
        },
        error: (xhr, status, error) => {
            jQuery(messageDiv).addClass('error');
            jQuery(messageDiv).removeClass('d-none');
            
            const jsonXhr = xhr.responseJSON;
            messageDiv.innerHTML += jsonXhr.text;
        }
    });
}

jQuery(() => {
    const converter = jQuery('.js-excel-converter');
    if(converter) {
        converter.on('click', (e) => {
            e.preventDefault();
            uploadFile();
        });
    }
});


// WEBPACK FOOTER //
// ./src/scripts/modules/excel-converter.js